import { render, staticRenderFns } from "./Phd.vue?vue&type=template&id=1416ea1c&scoped=true"
import script from "./Phd.vue?vue&type=script&lang=js"
export * from "./Phd.vue?vue&type=script&lang=js"
import style0 from "./Phd.vue?vue&type=style&index=0&id=1416ea1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1416ea1c",
  null
  
)

export default component.exports